module.exports = __webpack_public_path__ + "img/full2-min.c6a76512.png";